(() => {
  const containerSelector = '.wholesale_shopify_form';
  const styleId = 'rg-wholesale-form-style';
  const css = `
:host,
:host * {
  box-sizing: border-box;
}

:host {
  --inline-container-max-width: 1000px !important;
  --input-label-top: 2em;
}

input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]),
textarea,
select {
  background: #f6f2f0 !important;
  border: none !important;
  border-radius: 0.6rem !important;
  padding: 1.4rem 1.6rem !important;
  font-family: var(--font-heading-family), sans-serif !important;
  color: #68605a !important;
  box-shadow: none !important;
}

textarea {
  min-height: 16rem !important;
  resize: vertical !important;
}

[class*="formFieldContainer"]:has(textarea)::before {
  background-color: transparent !important;
}

input::placeholder,
textarea::placeholder {
  color: #68605a !important;
  opacity: 0.75 !important;
}

label {
  font-family: var(--font-heading-family), sans-serif !important;
  text-transform: uppercase !important;
  letter-spacing: 0.04em !important;
  color: #68605a !important;
  line-height: 0 !important;
  top: 15px !important;
}

button[type="submit"],
input[type="submit"],
button:not([type]) {
  background: var(--color-primary-button-background, #f7557d) !important;
  color: var(--color-primary-button-text, #ffffff) !important;
  border: none !important;
  border-radius: 0.6rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  font-family: var(--font-heading-family), sans-serif !important;
  padding: 1.6rem 2rem !important;
  min-height: 4.8rem !important;
  width: 100% !important;
  cursor: pointer !important;
}

button[type="submit"]:hover,
input[type="submit"]:hover,
button:not([type]):hover {
  background: var(--color-primary-button-hover-background, #e0426a) !important;
}

form {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  column-gap: 1.6rem !important;
  row-gap: 1.1rem !important;
  align-items: start !important;
}

form > div:has(shop-lead-capture) {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
}

form > *:has(textarea) {
  grid-column: 2 !important;
  grid-row: 1 / span 3 !important;
}

form > button[type="submit"],
form > input[type="submit"],
form > *:has(> button[type="submit"]) {
  grid-column: 2 !important;
  grid-row: span 2 / 6 !important;
  padding: 2.5rem 0 !important;
  align-items: center;
}

form > *:not(:has(textarea)):not(button[type="submit"]):not(input[type="submit"]):not(:has(> button[type="submit"])):not(:has(shop-lead-capture)) {
  grid-column: 1 !important;
}

@media (max-width: 768px) {
  form {
    display: block !important;
  }

  form > * {
    grid-column: auto !important;
    grid-row: auto !important;
    margin-bottom: 1.1rem !important;
  }
}
`.trim();

  const hasStyle = (root) =>
    root?.getElementById?.(styleId) || root?.querySelector?.(`#${styleId}`);

  const injectInto = (root) => {
    if (!root || hasStyle(root)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.append(style);
  };

  const walkAndStyle = (node) => {
    if (!node) return;

    const shadowRoot = node.shadowRoot;
    if (shadowRoot) {
      injectInto(shadowRoot);
      walkAndStyle(shadowRoot);
    }

    for (const child of node.children ?? []) {
      walkAndStyle(child);
    }
  };

  const applyStyles = () => {
    for (const container of document.querySelectorAll(containerSelector)) {
      walkAndStyle(container);
    }
  };

  const start = () => {
    let scheduled = false;
    const defer =
      window.requestAnimationFrame?.bind(window) ??
      ((callback) => window.setTimeout(callback, 0));
    const scheduleApply = () => {
      if (scheduled) return;
      scheduled = true;
      defer(() => {
        scheduled = false;
        applyStyles();
      });
    };

    applyStyles();

    if (window.MutationObserver) {
      const observer = new MutationObserver(scheduleApply);
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    let attempts = 0;
    const timer = setInterval(() => {
      applyStyles();
      attempts += 1;
      if (attempts > 20) clearInterval(timer);
    }, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    return;
  }

  start();
})();
